import { Prescription } from '../../../../types/models/Presc'

/**
 * basic_result の 3 欄（都道府県 2 + 点数表 1 + 機関 7）→ 統一医療機関コード 10 桁。
 * 読めていなければ null。**backend の full_hospital_code_of と同じ規則**で、桁は補わない —
 * マスタ由来の都道府県コードは常に 2 桁なので、10 桁にならないのは機関が引けなかった紙
 * （ダミー機関 = 都道府県 "1"・種別 "1"・機関 "0000000"）だけ。QR 直読（basic_result=null）や欄が空の紙も null。
 */
export const fullHospitalCodeOf = (presc: Prescription): string | null => {
  const basic = presc.basic_result
  if (!basic) return null
  const code = [
    basic.id_1_hospital_prefecture_code,
    basic.id_1_hospital_type_code,
    basic.id_1_hospital_code,
  ]
    .map((field) => String(field?.selected_option ?? ''))
    .join('')
  return /^\d{10}$/.test(code) ? code : null
}

export type FormatStatus = {
  /** 従来 7 項目を誰かが判断した（override json に居る or 編集ログがある） */
  is_format_annotated: boolean
  /** 保険β の段数が宣言済み */
  is_insurance_layout_declared: boolean
}

/**
 * 一覧の行に添える一言。様式が未判断なら「様式未設定」、保険欄の宣言だけ無ければ「保険欄 未設定」、
 * どちらも済みなら null（何も出さない）。色は使わない（重要度を色で出さない）。
 */
export const formatStatusLabel = (
  status: FormatStatus | undefined
): string | null => {
  if (!status) return null
  if (!status.is_format_annotated) return '様式未設定'
  if (!status.is_insurance_layout_declared) return '保険欄 未設定'
  return null
}
